// extracted by mini-css-extract-plugin
module.exports = {"linksCard":"LinkCard_linksCard__2g6kf","linkBox":"LinkCard_linkBox__3Adff"};